import { render, staticRenderFns } from "./ProdutosTabelaModal.vue?vue&type=template&id=032341a4"
import script from "./ProdutosTabelaModal.vue?vue&type=script&lang=js"
export * from "./ProdutosTabelaModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutosTabelaModal.vue?vue&type=style&index=0&id=032341a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports